<!--升降赛-->
<template>
  <div>
    <!-- 秩序册 开始 -->
    <div v-if="queryType === 'ZXC' && resultList">
      <div v-for="(item, index) in resultList" :key="index">
        <div
          style="text-align: center;font-size: 16px;font-weight: 600;margin-top: 15px;margin-bottom : 15px;padding: 6px;background: #666;color: #fff;"
        >
          {{ item.XMQC + "（" + item.ZHID + "组）" }}
        </div>
        <table
          class="xhsTableClass"
          style="width: 466px;"
          v-for="(contentItem, contentIndex) in item.CONTENT"
          :key="contentIndex"
        >
          <tr style="background: #dbdbdb;">
            <td>组别</td>
            <td>轮/场次</td>
            <td>场地</td>
            <td>日期</td>
            <td>时间</td>
            <td style="width: 150px;">对阵</td>
          </tr>
          <tr v-for="(mxItem, mxIndex) in contentItem.LCLIST" :key="mxIndex">
            <td>{{ mxItem.XMQC + mxItem.ZHID + "组" }}</td>
            <td>第{{ mxItem.LCH }}轮/{{ mxItem.CSSXH }}场</td>
            <td>{{ mxItem.CDH }}号场地</td>
            <td>{{ mxItem.RQ }}</td>
            <td>{{ mxItem.STARTTIME }}</td>
            <td style="width: 150px;">
              <div>
                {{
                  mxItem.ZNWZH1.indexOf("(0)") > -1 ? "轮空" : mxItem.RYXM1
                }}&nbsp;VS&nbsp;{{
                  mxItem.ZNWZH2.indexOf("(0)") > -1 ? "轮空" : mxItem.RYXM2
                }}
              </div>
              <div>
                {{ item.ZHID }}组{{
                  mxItem.ZNWZH1.indexOf("(0)") > -1 ? "轮空" : mxItem.ZNWZH1
                }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.ZHID }}组{{
                  mxItem.ZNWZH2.indexOf("(0)") > -1 ? "轮空" : mxItem.ZNWZH2
                }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 秩序册 结束 -->

    <!-- 成绩册 开始 -->
    <div v-if="queryType === 'CJC'">
      <div v-for="(item, index) in resultList" :key="index">
        <div
          style="text-align: center;font-size: 16px;font-weight: 600;margin-top: 15px;margin-bottom : 15px;padding: 6px;background: #666;color: #fff;"
        >
          {{ item.XMQC + "（" + item.ZHID + "组）" }}
        </div>
        <table
          class="xhsTableClass"
          style="width: 766px;"
          v-for="(contentItem, contentIndex) in item.CONTENT"
          :key="contentIndex"
        >
          <tr style="background: #dbdbdb;">
            <td>组别</td>
            <td>对阵1</td>
            <td>位置1</td>
            <td>运动员1</td>
            <td>比分</td>
            <td>对阵2</td>
            <td>位置2</td>
            <td>运动员2</td>
            <td>轮/场次</td>
            <td>场地</td>
            <td>日期</td>
            <td>比赛用时</td>
          </tr>
          <tr v-for="(mxItem, mxIndex) in contentItem.LCLIST" :key="mxIndex">
            <td>{{ mxItem.XMQC + mxItem.ZHID + "组" }}</td>
            <td>
              {{ mxItem.ZNWZH1.indexOf("(0)") > -1 ? "轮空" : mxItem.POSSWZH1 }}
            </td>
            <td>
              {{ mxItem.ZNWZH1.indexOf("(0)") > -1 ? "轮空" : mxItem.ZNWZH1 }}
            </td>
            <td>
              {{ mxItem.ZNWZH1.indexOf("(0)") > -1 ? "轮空" : mxItem.RYXM1 }}
            </td>
            <td>
              {{ mxItem.ISPF1 === "1" || mxItem.ISDCQQ1 === "1" ? "(弃)" : ""
              }}{{ mxItem.MARK1 }}:{{ mxItem.MARK2
              }}{{
                mxItem.ISPF2 === "1" || mxItem.ISDCQQ2 === "1" ? "(弃)" : ""
              }}
            </td>
            <td>
              {{ mxItem.ZNWZH2.indexOf("(0)") > -1 ? "轮空" : mxItem.POSSWZH2 }}
            </td>
            <td>
              {{ mxItem.ZNWZH2.indexOf("(0)") > -1 ? "轮空" : mxItem.ZNWZH2 }}
            </td>
            <td>
              {{ mxItem.ZNWZH2.indexOf("(0)") > -1 ? "轮空" : mxItem.RYXM2 }}
            </td>
            <td>第{{ mxItem.LCH }}轮/{{ mxItem.CSSXH }}场</td>
            <td>{{ mxItem.CDH }}号场地</td>
            <td>{{ mxItem.RQ }}</td>
            <td>{{ mxItem.BCYS.length > 0 ? mxItem.BCYS + "分钟" : "" }}</td>
          </tr>
        </table>

        <table
          class="xhsTableClass"
          style="margin-top:25px;width:100%;"
          v-if="queryType === 'CJC'"
        >
          <tr>
            <td>
              名次
            </td>
            <td>
              队名
            </td>
            <td>
              运动员姓名
            </td>
          </tr>
          <tr v-for="(mcItem, mcIndex) in item.MCLIST" :key="mcIndex">
            <td>
              {{ mcItem.MCDATA }}
            </td>
            <td>
              {{ mcItem.DWJC1 }}
            </td>
            <td>
              {{
                mcItem.RYXM1 +
                  (mcItem.RYXM2.length > 0 ? "/" + mcItem.RYXM2 : "")
              }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 成绩册 结束 -->
  </div>
</template>

<script>
export default {
  name: "SlsCdViewCom",
  components: {},
  props: {
    queryType: {
      type: String,
      default: ""
    },
    resultList: {
      type: Array,
      default: null
    },
    pmms: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.xhsTableClass {
  background: #fff;
  border-collapse: collapse;
}
.xhsTableClass td {
  width: 50px;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/SlsCdViewCom.vue